import isEqual from 'lodash/isEqual'

export const reducer = (state, action) => {
  const vendorObject = {}
  if (Array.isArray(action?.vendors)) {
    action?.vendors?.forEach((vendor) => {
      vendorObject[vendor.id] = vendor.name
    })
  }
  switch (action.type) {
    case 'update_vendors':
      if (isEqual(vendorObject, state?.vendors)) {
        return state
      } else if (
        state?.selectedVendor &&
        Object.keys(vendorObject).includes(state?.selectedVendor)
      ) {
        return {
          ...state,
          vendors: vendorObject,
        }
      } else {
        return {
          ...state,
          vendors: vendorObject,
          selectedVendor: Object.keys(vendorObject)[0],
        }
      }
    case 'update_selected_vendor':
      return {
        ...state,
        selectedVendor: action.selectedVendor,
      }

    default:
      return state
  }
}

export const initialState = {
  vendors: null,
  selectedVendor: null,
}
